import { environment } from './../../../../../environment/environment';
import { PusherService } from './../../../../core/services/contact/pusher.service';
import { ContactService } from './../../../../core/services/contact/contact.service';
import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { failedDelete } from './../../../../core/models/messages';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  Subject,
  Subscription,
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  takeUntil,
} from 'rxjs';
import Swal from 'sweetalert2';
import { CompanyService } from '@core/services/company/company.service';

@Component({
  selector: 'app-chatclientfinal',
  templateUrl: './chatclientfinal.component.html',
  styleUrls: ['./chatclientfinal.component.css'],
})
export class ChatclientfinalComponent {
  headerClass: any;
  messages: any;
  messagesReciveds: any;
  newMessage: string = '';
  totalUsers: any;
  profil_image: any;
  last_name: any;
  first_name: any;
  users: any;
  firstnameinter:any
  lastnameinter:any
  image:any
  entreprise:any
  roleintervenant:any
  userIds: any;
  currentConversationUserId: number | null = null;
  currentUser: any;
  url: string = environment.baseUrl;
  profil_id: any;
  messagesSubscription!: Subscription;
  selectedUser: any;
  ListMessages: any;
  dataEmployeeWithCompany: any;
  dataCompanyWithEmployees: any;
  dataAdmin: any;
  idinter: any;
  searchInputSubject = new Subject<string>();
  searchInputSubjectUsers = new Subject<string>();
  private unsubscribeAll: Subject<void> = new Subject();
  typeintervenant: string | null | number =
  this.localStorageService.getData('typeintervenant');
  esn_id: any;
  constructor(
    private pusherService: PusherService,
    private chatService: ContactService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService, private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {

    this.idinter = Number(this.localStorageService.getData('id'));  // Convert to a number
    console.log("idinter as number:", this.idinter);
    this.cdRef.detectChanges(); 
    this.getuserByIdistervenant();
    

    this.getHeaderClass();
   
    this.getId();
    this.messagesSubscription = this.pusherService.messages$.subscribe(
      (message: any) => {
        console.log('message', message);
        this.messages = this.messages.concat(message);
        console.log('message2', this.messages);
        this.changeDetectorRef.detectChanges();
      }
    );

    this.chatService.getMessageSentObservable().subscribe(() => {
      this.loadMessagesEmitter(this.currentConversationUserId);
    });
    this.loadMessagesEmitter(this.currentConversationUserId);
    this.getListMessage();
    if(!this.typeintervenant)
      {
        this.getUser();

    }
    else{
      this.getuserByIdistervenant();
    }
    
 
    this.searchInputSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchName) => {
          this.spinner.show();
          const data = {
            search: searchName.trim().toLowerCase(),
          };
          console.log(
            '%centreprises.component.ts line:203 data search',
            'color: #007acc;',
            data
          );
          return this.chatService.searchListMessage(data, 0, 0).pipe(
            catchError(() => {
              this.spinner.hide();
              return [];
            })
          );
        })
      )
      .subscribe((res: any) => {
        this.ListMessages = res.data;
        this.spinner.hide();
      });
    this.searchInputSubjectUsers
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchName) => {
          const data = {
            search: searchName.trim().toLowerCase(),
          };

          this.spinner.show();

          return this.chatService.searchListUserclient(data).pipe(
            catchError(() => {
              this.spinner.hide();
              return [];
            })
          );
        })
      )
      .subscribe((res: any) => {
        console.log("ressssssssssssssssssssssssssssssssssssss",res)
        this.users = res.employeeWithCompany;
        this.dataAdmin = res.admin;
        this.dataEmployeeWithCompany = res.employeeWithCompany;
        this.spinner.hide();
      });
  }
  profil_idd:any
  getUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    console.log("this.currentUser",this.currentUser)
    this.first_name = JSON.parse(this.currentUser).company.name;
    this.profil_image = JSON.parse(this.currentUser).company.logo;
    this.profil_id = JSON.parse(this.currentUser).id;
    this.esn_id = JSON.parse(this.currentUser).company.id;
  }
  async getuserByIdistervenant() {

    try {
      this.spinner.show();
      
      const res: any = await this.companyService
        .getUserById(this.idinter)
        .pipe(takeUntil(this.unsubscribeAll))
        .toPromise(); // Convert observable to promise
  
      console.log('item of res ', res);
      this.firstnameinter = res?.body?.data?.first_name;
      console.log("name", this.firstnameinter);
      this.lastnameinter = res?.body?.data?.last_name;
      this.profil_idd=res?.body?.data?.id
      console.log("this.profil_idd", this.profil_idd);
      this.image = res?.body?.data?.image_url;
      this.entreprise = res?.body?.data?.company_name;
      console.log("this.entreprise", this.entreprise);
      this.roleintervenant = res?.body?.data?.employee_role_name;
  
    } catch (error) {
      console.error('An error occurred', error);
    } finally {
      this.spinner.hide();
    }
  }
  
  getFirstLetter(user: any): string {
    if (user?.full_name && user?.full_name?.length > 0) {
      return user?.full_name[0];
    } else {
      return '';
    }
  }

  loadMessagesEmitter(userId?: any) {
    console.log('user id', userId);
    this.chatService.getMessagesEmitter(userId, null, null).subscribe((messages) => {
     
      this.messages = messages?.data.map((message: any) => {
        
        message.elapsedTime = this.formatElapsedTime(message.created_at);
        return message;
      });
    });
  }
  messagePage() {
    ;
  }
  sendMessage() {
    if (this.newMessage.trim() !== '') {
      this.chatService
        .sendMessage(this.currentConversationUserId, this.newMessage, null, null)
        .subscribe(() => {
          this.newMessage = '';
        });
    }
    this.getListMessage();
    console.log('chanel', this.pusherService.channel);
  }
  formatElapsedTime(created_at: string): string {
    const currentTime = moment();
    const messageTime = moment(created_at);
    const duration = moment.duration(currentTime.diff(messageTime));

    if (duration.asMinutes() <= 59) {
      const minutes = Math.floor(duration.asMinutes());
      if (minutes < 1) {
        return "à l'instant";
      } else if (minutes === 1) {
        return '1 minute';
      } else {
        return `${minutes} minutes`;
      }
    } else if (duration.asHours() <= 23) {
      const hours = Math.floor(duration.asHours());
      if (hours === 1) {
        return '1 heure';
      } else {
        return `${hours} heures`;
      }
    } else if (duration.asDays() <= 6) {
      const days = Math.floor(duration.asDays());
      if (days === 1) {
        return '1 jour';
      } else {
        return `${days} jours`;
      }
    } else {
      const weeks = Math.floor(duration.asDays() / 7);
      if (weeks === 1) {
        return '1 semaine';
      } else {
        return `${weeks} semaines`;
      }
    }
  }

  getListMessage() {
    this.chatService.getListMessage().subscribe({
      next: (res) => {
        this.ListMessages = res.data;
        console.log('user messages ********** ', this.ListMessages);
      },
      error: (e) => {
        console.log('get messages error ===== ', e);
      },
    });
  }

  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        const userString = params.params['user'];
      },
    });
  }
  getHeaderClass(): void {
    this.headerClass = this.chatService.getHeaderClass();
    console.log('classeHeader', this.headerClass);
    this.currentConversationUserId = this.headerClass.id;
    this.startConversation(this.currentConversationUserId);
    this.loadMessagesEmitter(this.currentConversationUserId);
    if(!this.typeintervenant){
      this.getUser();
    }
    else{
      this.getuserByIdistervenant()
    }
   
    this.userSelected(this.headerClass);
  }

  userSelected(user: any) {
    this.selectedUser = user;
    console.log('selectedUser', this.selectedUser.length);
    this.startConversation(user?.id);
    console.log('userIdsuserIdsuserIds22222', user?.id);
  }
  newUser: any;
  startConversation(user: any) {
    this.userIds = this.ListMessages?.map((user: any) => user.id);
    console.log('userIdsuserIdsuserIds', this.userIds);
    this.currentConversationUserId = user;
    this.loadMessagesEmitter(user);
  }
  applyFilterUsers(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchInputSubjectUsers.next(filterValue);
  }

  // applyFilterUsers(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   let data = {
  //     search: filterValue.trim().toLowerCase(),
  //   }
  //   this.spinner.show()
  //   console.log('%centreprises.component.ts line:203 data search', 'color: #007acc;', data);
  //   this.chatService.searchListUser(data).pipe(takeUntil(this.unsubscribeAll)).subscribe({
  //     next: (res) => {
  //       this.users = res.admin.concat(res.employeeWithCompany);
  //       this.dataAdmin = res.admin
  //       this.dataEmployeeWithCompany = res.employeeWithCompany
  //       this.spinner.hide()
  //     },
  //     error: () => {
  //       this.spinner.hide()
  //     }
  //   })
  // }
  applyFilterMessage(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchInputSubject.next(filterValue);
  }
  // applyFilterMessage(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.searchInputSubject.next(filterValue)
  //   let data = {
  //     search: filterValue.trim().toLowerCase(),
  //   }

  //   this.spinner.show()

  //   console.log('%centreprises.component.ts line:203 data search', 'color: #007acc;', data);

  //   this.chatService.searchListMessage(data).pipe(takeUntil(this.unsubscribeAll)).subscribe({
  //     next: (res) => {

  //       this.ListMessages = res.data;
  //       this.spinner.hide()
  //     },
  //     error: () => {
  //       this.spinner.hide()
  //     }
  //   })
  // }
  openDeleteQuestionAlert(receiverId: any) {
    Swal.fire({
      title: `Êtes-vous sûr de vouloir supprimer cette conversation?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteConversation(receiverId);
      } else if (result.isDismissed) {
        Swal.fire(failedDelete, '', 'error');
      }
    });
  }
  deleteConversation(receiverId: any): void {
    this.chatService.deleteConversation(receiverId).subscribe(
      (response) => {
        console.log('Conversation deleted successfully', response);
        this.messages = this.messages.filter(
          (message: any) => message.id === receiverId
        );
        this.ListMessages = this.ListMessages.filter(
          (message: any) => message.id === receiverId
        );
      },
      (error) => {
        console.error('Error deleting Conversation', error);
      }
    );
  }
  readMessage(id: any) {
    this.spinner.show();
    let data = { id: id };
    this.chatService
      .readMessage(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log("res read message",res)
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
        },
      });
  }
  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
    this.messagesSubscription.unsubscribe();
  }
}
